import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FC, FR} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';
import {ITariffGroup} from "Types/psychology/tariff";

interface TariffGroupCardProps {
    group: ITariffGroup;
}

const TariffGroupCard: React.FC<TariffGroupCardProps> = ({group}) => {
    const {plt} = useTheme();
    const location = useLocation();
    const linkTo = location.pathname.includes('cabinet')
        ? `/cabinet/tariff-groups/${group.id}`
        : `/tariff-groups/${group.id}`;

    return (
        <FC pb={2} rounded={4} maxW={350} minW={350}
            cursorPointer
            cls={'hover-scale-4'}
            bg={`${plt.colors.secondary.light}33`}
            color={plt.text.primary80}>
            <Link
                to={linkTo}
                style={{color: plt.text.primary80}}
                className="text-decoration-none flex-grow-1"
            >
                <FC h={'100%'}>
                    <FC g={1}>
                        {group.picture && (
                        <img
                            src={group.picture}
                            alt={group.name}
                            className="card-img-top maxh-150px w-100 object-fit-cover rounded-4"
                        />
                    )}
                    </FC>
                    <FC px={2} grow pt={1}>
                        <FC>
                            <h5>{group.name}</h5>
                            <p style={{whiteSpace: 'pre-wrap'}}>{group.description}</p>
                        </FC>
                        {group.tariffs ? (
                            <FC mt={'auto'}>
                                <span>Содержит {group.tariffs.length} тарифов</span>
                            </FC>
                        ) : (
                            <FR></FR>
                        )}
                    </FC>
                </FC>
            </Link>
        </FC>
    );
};

export default TariffGroupCard;
